import { Injectable } from '@angular/core';
import { environment } from '@app-env';

@Injectable({
    providedIn: 'root',
})
export class LoggingService {
    constructor() {}

    public static log(message?: any, ...optionalParams: any[]): void {
        if (!environment.production) {
            if (optionalParams.length === 0) {
                console.log(message);
            } else {
                console.log(message, optionalParams);
            }
        }
    }

    public static error(message?: any, ...optionalParams: any[]): void {
        if (!environment.production) {
            if (optionalParams.length === 0) {
                console.error(message);
            } else {
                console.error(message, optionalParams);
            }
        }
    }
}
